var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Login',{attrs:{"emailText":"Sign in with Email","title":"Sign in","btnText":"Sign in","isLogin":true}})}
var staticRenderFns = []

export { render, staticRenderFns }